import React from 'react'

const Core_Java = () => {
  return (
    <div>
        {/* collapseThirtyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingThirtyTwo">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#collapseThirtyTwo" 
                        aria-expanded="false" 
                        aria-controls="collapseThirtyTwo">
                    Core Java<span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseThirtyTwo" className="accordion-collapse collapse" aria-labelledby="headingThirtyTwo" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Getting started - What is JAVA? Java Language Environment, Introduction to java language, JVM and its working, Features of java language, Difference between JDK, JRE and JVM</li>
                        <li>OOP’s Concepts, OOP’s Features</li>
                        <li>Basic Language Constructs - Data types, Operators in java, Conditional Statement constructer, Looping Statement, Arrays, Scanner Class</li>
                        <li>Major Pillars of JAVA - Encapsulation, Abstraction, Inheritance, Polymorphism Creating classes and Objects - Declaring variable and accessing it. Types of Objects & Garbage Collection</li>
                        <li>Methods, Constructors, Use of Access Specifiers, static and This keyword</li>
                        <li>Inheritance- Type of inheritance, Concept of Polymorphism, Method Overloading, Method Overriding, Super Keyword.</li>
                        <li>Packages, import and static import</li>
                        <li>String, Immutable String Comparison, String Concatenation, Substring, Methods of String class, StringBuffer class, StringBuilder class.</li>
                        <li>Exception Handling - What is Exception, Exception type & hierarchy, Handling Exception using try - catch, throw & throws, Custom Exception, Finally Block.</li>
                        <li>Collection Framework : List, Set, Map, Interfaces </li>
                        <li>File handling in java using file I/O Stream</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Core_Java